import { Plus } from "lucide-react";

import { useAddAgentDialog } from "@/components/AddAgentDialog";

export function CtaBlock() {
	const { openAddAgentDialog } = useAddAgentDialog();

	return (
		<section className="relative py-8 sm:py-10">
			<div className="relative mx-auto max-w-5xl">
				<div className="flex flex-col items-stretch gap-3 py-3 sm:flex-row sm:items-center sm:justify-end sm:gap-4">
					<button
						type="button"
						onClick={openAddAgentDialog}
						className="inline-flex min-h-10 items-center justify-center gap-2 bg-brand px-5 font-mono text-sm uppercase tracking-[0.12em] text-background transition-[background-color,transform] hover:bg-brand-hover active:scale-[0.96] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-background"
					>
						<Plus className="size-3.5" aria-hidden="true" />
						Add your agent
					</button>
				</div>
			</div>
		</section>
	);
}
